import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBackupCheck = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-backup-check';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.28c-3.024.218-5.769 2.016-7.133 4.671-1.586 3.087-1.174 6.738 1.064 9.409.357.427.7.76 1.229 1.196.198.163.387.321.419.351.051.047-.063.176-.84.954l-.898.899H9.76v-4.579l-.856.855-.856.855-.432-.355c-.598-.492-.845-.726-1.168-1.107-.748-.883-1.323-2.041-1.543-3.111a7.1 7.1 0 0 1 .2-3.638 7.22 7.22 0 0 1 5.088-4.697c.649-.162.987-.2 1.807-.2s1.158.038 1.807.2a7.24 7.24 0 0 1 5.07 4.633c.473 1.352.48 3.034.018 4.424a7.2 7.2 0 0 1-5.028 4.681c-.555.145-1.173.239-1.567.239H12v1.52h.17c.722-.001 1.817-.194 2.625-.464 4.342-1.451 6.809-5.918 5.682-10.288-.683-2.649-2.637-4.832-5.251-5.868-1.153-.457-2.598-.673-3.886-.58m1.62 7.7a82 82 0 0 1-1.52 1.5c-.011 0-.459-.351-.996-.781a28 28 0 0 0-.986-.77c-.091.094-.898 1.13-.898 1.152 0 .036 2.945 2.399 2.99 2.399.017 0 .921-.891 2.01-1.98l1.979-1.98-.519-.52a10 10 0 0 0-.54-.52c-.011 0-.695.675-1.52 1.5"
    })
  }));
});
export default SvgBackupCheck;